import React, { Component } from 'react';
import { connect } from 'react-redux';
import ReactPlayer from 'react-player';
import PropTypes from 'prop-types';
import ReactHtmlParser from 'react-html-parser';
import ReactGA from 'react-ga';

import './Style';


class VideoContainer extends Component {
    constructor() {
        super();

        this.state = {
            videoFrameHeight: 360,
            error: null,
            errorInfo: null
        }

        this.onResize = this.onResize.bind(this);
    }

    componentDidMount() {
        window.addEventListener('resize', this.onResize, false);
        this.onResize();
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.onResize, false);
    }

    onResize() {
        if (!this.props.video.videos.length || !this.header) {
            return false;
        }

        const headerMargin = Number(window.getComputedStyle(this.header).marginBottom.replace('px', ''))
            + Number(window.getComputedStyle(this.header).marginTop.replace('px', ''));
        const headerHeight = this.header.offsetHeight + headerMargin;

        if (window.screen.availHeight * 0.95 < window.innerWidth * 9 / 16) {
            this.setState({
                videoFrameHeight: window.screen.availHeight * 0.95 + headerHeight
            });
        } else {
            this.setState({
                videoFrameHeight: window.innerWidth * 9 / 16 + headerHeight
            });
        }
    }

    onPlay() {
        // ReactGA.event({
        //     category: 'video',
        //     action: 'play video'
        // });
    }

    onPause() {
        // ReactGA.event({
        //     category: 'video',
        //     action: 'pause video'
        // });
    }

    componentDidCatch(error, errorInfo) {
        this.setState({
            error,
            errorInfo
        }, () => {
            console.error(error, errorInfo);
        });
    }

    render() {
        const { video } = this.props;
        const { videoFrameHeight, error } = this.state;

        if (!video.videos.length || error) {
            return null;
        }

        const videos = () => {
            // if (true) {
                return video.videos.map((item, i) => {
                    if (item.custom_content_type === 'id') {
                        const url = item.type === 'youtube'
                            ? `https://www.youtube.com/watch?v=${item.content}`
                            : `https://vimeo.com/${item.content}`;
                        return (
                            <div key={i} className="video-component" style={{ height: videoFrameHeight + 'px' }}>
                                <h2 className="section-header" ref={header => this.header = header}>
                                    {item.title || 'Video'}
                                </h2>
                                <ReactPlayer
                                    className="iframe-container"
                                    url={url}
                                    width='100%'
                                    controls={true}
                                    onPlay={this.onPlay}
                                    onPause={this.onPause}
                                />
                            </div>
                        );

                    } else {
                        return <div key={i} className="video-component" style={{ height: videoFrameHeight + 'px' }}>
                            <h2 className="section-header" ref={header => this.header = header}>
                                {video.embedTitle ? video.embedTitle : 'Video'}
                            </h2>
                            <div className="iframe-container">
                                {ReactHtmlParser(item.content)}
                            </div>
                        </div>
                    }
                });
            // } else {
            //     return video.videos.map((item, i) => {
            //         return (
            //             <div key={i} className="video-component" style={{ height: videoFrameHeight + 'px' }}>
            //                 <h2 className="section-header" ref={header => this.header = header}>
            //                     {video.embedTitle ? video.embedTitle : 'Video'}
            //                 </h2>
            //                 <div className="iframe-container">
            //                     {ReactHtmlParser(item)}
            //                 </div>
            //             </div>
            //         )
            //     });

            // }
        }

        return (
            <div id='video' className="video-container">
                {videos()}
            </div>
        );
    }
}

VideoContainer.propTypes = {
    video: PropTypes.object.isRequired
};

const mapStateToProps = (state) => {
    return {
        video: state.video
    }
}

export default connect(mapStateToProps)(VideoContainer)
